import { render, staticRenderFns } from "./HouseFundsPerson.vue?vue&type=template&id=86ebd3a2&scoped=true&"
import script from "./HouseFundsPerson.vue?vue&type=script&lang=js&"
export * from "./HouseFundsPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ebd3a2",
  null
  
)

export default component.exports